export enum Views {
  DESIGN = 'design',
  REVIEW = 'review',
  PERSONALIZATION = 'personalization',
  TERMS = 'terms-of-service',
  REVIEW_UPDATE_PREVIEW = 'review_updatepreview',
}

export enum ToolKeys {
  TEXT = 'text',
  MONOGRAM = 'monogram',
  JERSEY = 'jersey',
  ARTWORK = 'artwork',
  GROUP_NAME = 'group_name',
  GROUP_MONOGRAM = 'group_monogram',
  GROUP_JERSEY = 'group_jersey',
  GROUP_NAME_TITLE = 'group_name_title',
}

export enum ToolViewModes {
  INPUT = 'input',
  COLOR = 'color',
  ASSET = 'asset',
  ASSET_FRAMES = 'asset_frames',
}
